import useIsInExperiment from '~/hooks/common/experiments/useIsInExperiment';

export default function useIsInZipExperiment() {
  return useIsInExperiment('car-merch-ui-vdp-zipcode-hero', 'treatment');
}
